module.exports = __webpack_public_path__ + "static/media/s_red.410217e5.mp3";